import { defineMessages } from 'react-intl';

export default defineMessages({
    producerCode: {
        id: 'ml.gateway.common.newQuoteDialog.PRODUCER CODE',
        defaultMessage: 'PRODUCER CODE'
    },
    effectiveDate: {
        id: 'ml.gateway.common.newQuoteDialog.EFFECTIVE DATE',
        defaultMessage: 'EFFECTIVE DATE'
    },
    zipCode: {
        id: 'ml.gateway.common.newQuoteDialog.ZIP CODE',
        defaultMessage: 'ZIP CODE'
    },
    product: {
        id: 'ml.gateway.common.newQuoteDialog.PRODUCT',
        defaultMessage: 'PRODUCT'
    },
    offering: {
        id: 'ml.gateway.common.newQuoteDialog.OFFERING',
        defaultMessage: 'OFFERING'
    },
    noProductAvailable: {
        id: 'ml.gateway.common.newQuoteDialog.No products are available for this effective date or zip code.',
        defaultMessage: 'No products are available for this effective date or zip code.'
    },
    quote: {
        id: 'ml.gateway.common.newQuoteDialog.QUOTE #',
        defaultMessage: 'QUOTE #'
    },
    include: {
        id: 'ml.gateway.common.newQuoteDialog.INCLUDE',
        defaultMessage: 'INCLUDE'
    },
    selectDiffProducerCode: {
        id: 'ml.gateway.common.newQuoteDialog.Please try selecting a different producer code',
        defaultMessage: 'Please try selecting a different producer code'
    },
    quoteNew: {
        id: 'ml.gateway.common.newQuoteDialog.NEW',
        defaultMessage: 'NEW'
    },
    removeQuote: {
        id: 'ml.gateway.common.newQuoteDialog.Remove',
        defaultMessage: 'Remove'
    },
    startAQuote: {
        id: 'ml.gateway.common.newQuoteDialog.Start a quote',
        defaultMessage: 'Start a quote'
    },
    addAnotherText: {
        id: 'ml.gateway.common.newQuoteDialog.addAnotherText',
        defaultMessage: '"Add another" to create a bundle, or "Start Quote". '
    },
    addAnotherButton: {
        id: 'ml.gateway.common.newQuoteDialog.ADD ANOTHER',
        defaultMessage: 'ADD ANOTHER'
    },
    startQuoteButton: {
        id: 'ml.gateway.common.newQuoteDialog.START QUOTE',
        defaultMessage: 'START QUOTE'
    },
    quoteBundleButton: {
        id: 'ml.gateway.common.newQuoteDialog.QUOTE BUNDLE',
        defaultMessage: 'QUOTE BUNDLE'
    },
    rateCapped: {
        id: 'ml.gateway.common.newQuoteDialog.Rate Capped',
        defaultMessage: 'Rate Capped'
    },
    nonRateCapped: {
        id: 'ml.gateway.common.newQuoteDialog.Non Rate Capped',
        defaultMessage: 'Non Rate Capped'
    },
    premiumPerYear: {
        id: 'ml.gateway.common.newQuoteDialog.premium /year',
        defaultMessage: '{totalPremium} /year'
    },
    premiumPerHalfYear: {
        id: 'ml.gateway.common.newQuoteDialog.premium /6 months',
        defaultMessage: '{totalPremium} /6 months'
    },
    noValuePerYear: {
        id: 'ml.gateway.common.newQuoteDialog.$- /year',
        defaultMessage: '$- /year'
    },
    noValuePerHalfYear: {
        id: 'ml.gateway.common.newQuoteDialog.$- /6 months',
        defaultMessage: '$- /6 months'
    },
    noValue: {
        id: 'ml.gateway.common.newQuoteDialog.$-',
        defaultMessage: '$-'
    },
    savedQuotes: {
        id: 'ml.gateway.common.newQuoteDialog.Saved quotes',
        defaultMessage: 'Saved quotes'
    },
    savedQuotesDesc: {
        id: 'ml.gateway.common.newQuoteDialog.(Premiums subject to change based on validation of quote information and ordering of consumer reports)',
        defaultMessage: '(Premiums subject to change based on validation of quote information and ordering of consumer reports)'
    },
    pastEffectiveDateWarning: {
        id: 'ml.gateway.common.newQuoteDialog.Please review the effective date as it’s a date in the past',
        defaultMessage: 'Please review the effective date as it’s a date in the past'
    },
    bundledBookrollWarningMsg: {
        id: 'ml.gateway.common.newQuoteDialog.bundledBookrollWarningMsg',
        defaultMessage: 'Reminder: Your customer was previously quoted as a part of a consolidation. If you would like to proceed or change the previously quoted policies, contact your consolidation manager. To begin a brand new quote, Start Quote.'
    },
    selectedBookrollWarningMsg: {
        id: 'ml.gateway.common.newQuoteDialog.selectedBookrollWarningMsg',
        defaultMessage: 'You selected a quote which is part of a consolidation. To proceed, unselect quotes from previous bundle to initiate another quote. If you would like to proceed with the consolidation, please contact your consolidation manager.'
    },
    nonSelectedBookrollWarningMsg: {
        id: 'ml.gateway.common.newQuoteDialog.nonSelectedBookrollWarningMsg',
        defaultMessage: 'Reminder: Policies which are part of a consolidation cannot be bundled with non-consolidated policies. The non-consolidated policies must be issued separately.'
    },
    genericErrorMessage: {
        id: 'ml.gateway.common.newQuoteDialog.genericErrorMessage',
        defaultMessage: 'Due to technical issue, the bundle validation has failed. Please try again later or contact customer service for assistance.'
    },
    periodStartDatePopupTitle: {
        id: 'ml.gateway.common.newQuoteDialog.periodStartDate.Do you want to change the effective date of your quote?',
        defaultMessage: 'Do you want to change the effective date of your quote?',
    },
    compRaterCR: {
        id: 'ml.gateway.common.newQuoteDialog.CR',
        defaultMessage: 'CR',
    },
    originalCRQuote: {
        id: 'ml.gateway.common.newQuoteDialog.Original CompRater Quote',
        defaultMessage: 'Original CompRater Quote',
    },
    rateCappedShortForm: {
        id: 'ml.gateway.common.newQuoteDialog.RC',
        defaultMessage: 'RC'
    },
    nonRateCappedShortForm: {
        id: 'ml.gateway.common.newQuoteDialog.NRC',
        defaultMessage: 'NRC'
    },
    contactBookManager: {
        id: 'ml.gateway.common.newQuoteDialog.Quote has not been completed. Please contact your Book Consolidation manager.',
        defaultMessage: 'Quote has not been completed. Please contact your Book Consolidation manager.'
    },
    quoteNotComplete: {
        id: 'ml.gateway.common.newQuoteDialog.Quote is not complete',
        defaultMessage: 'Quote is not complete'
    },
});
